const apiUrlSetting = import.meta.env.VITE_APIURL;
const baseUrl = !apiUrlSetting || apiUrlSetting === 'auto' ? window.location.origin + '/api' : apiUrlSetting;

export const API_URL = baseUrl + '/api';
export const WS_URL = baseUrl;

// Runtime config — populated by initConfig() before app starts
export let AUTH_MODE = '';
export let AUTH_CLIENTID = '';
export let AUTH_TENANTID = '';
export let AUTH_RETURN_URL = window.location.origin;
export let ENABLE_DEMO_FEATURES = false;

export async function initConfig(): Promise<void> {
  try {
    const response = await fetch(`${WS_URL}/api/config/public`);
    const config = await response.json();
    AUTH_MODE = config.authMode || 'windows';
    ENABLE_DEMO_FEATURES = config.enableDemoFeatures || false;
    if (config.azureAd) {
      AUTH_CLIENTID = config.azureAd.clientId;
      AUTH_TENANTID = config.azureAd.tenantId;
    }
    console.log('Config fetched from API:', config);
  } catch (e) {
    console.warn('Failed to fetch config from API, falling back to env vars', e);
    // Fallback for dev/offline — read from env vars if API unreachable
    AUTH_MODE = import.meta.env.VITE_AUTHMODE || 'windows';
    AUTH_CLIENTID = import.meta.env.VITE_AUTHCLIENTID || '';
    AUTH_TENANTID = import.meta.env.VITE_AUTHTENANTID || '';
    ENABLE_DEMO_FEATURES = import.meta.env.VITE_ENABLE_DEMO_FEATURES === 'true';
  }
  AUTH_RETURN_URL = window.location.origin;
}
